import React, { PureComponent, ReactElement } from 'react';

import { Button } from '@philips-emr/tws-components';
import { CloseEvent } from '@philips-emr/tws-core/lib/component/types';
import { isFunction, propagateProps } from '@philips-emr/tws-utils';

import './dialog-dock.scss';
import { DialogButton } from '../dialog-service';

interface DialogDockProps {
  children?: ReactElement | ReactElement[];
  dockButtons?: DialogButton[],
  onClose?: (event: CloseEvent) => void;
  uuid: string;
}

export default class DialogActionDock extends PureComponent<DialogDockProps> {

  private renderDock(): ReactElement[] | null {
    const { children } = this.props;

    if (children && Array.isArray(children) && children.length) {
      return propagateProps(children, {
        onClick: () => this.closeModal(),
      });
    }

    return this.renderBottons();
  }

  private renderBottons(): ReactElement[] | null {
    const { dockButtons } = this.props;

    if (!dockButtons) {
      return null;
    }

    const result = dockButtons.map(dock => {
      return <Button
        key={dock.title}
        onClick={this.wrapActionButton(dock.action)}
        theme={dock.type}
        value={dock.title}
      />;
    });

    return result;
  }

  private wrapActionButton(action?: () => void): () => void {
    return () => {
      this.closeModal();

      if (isFunction(action)) {
        action();
      }
    };
  }

  private closeModal(): boolean {
    const { onClose } = this.props;

    if (isFunction(onClose)) {
      onClose(new CloseEvent());
    }

    return true;
  }

  public render(): ReactElement {
    return (
      <div className="c-dialog__content-wrapper__actions" >
        {this.renderDock()}
      </div>
    );
  }
}
